
import { checkIsBlockQuote } from "./quote.helper";

export class QuoteCommand {
  constructor(editor) {
    this.editor = editor;
  }

  execute() {
    const selection = this.editor.selection;
    const selectedBlocks = selection.getSelectedBlocks();

    if (selectedBlocks.length === 0) return;

    const filterBlocks = selectedBlocks.filter(
      (block) => block.tagName.toLowerCase() !== "li",
    );

    const isChecked = checkIsBlockQuote({ blocks: filterBlocks });

    // Save selection trước khi modify DOM
    const savedSelection = selection.save();

    // Thực hiện wrap/unwrap
    if (isChecked) {
      this.unwrapBlockquote({ blocks: filterBlocks });
    } else {
      this.wrapWithBlockquote({ blocks: filterBlocks });
    }

    // Restore selection sau khi modify DOM
    selection.restore(savedSelection);
  }

  wrapWithBlockquote = ({ blocks }) => {
    if (!blocks.length) {
      return;
    }

    blocks.forEach((block) => {
      // tránh wrap lại blockquote
      if (block.tagName.toLowerCase() === "blockquote") return;

      const parent = block.parentNode;
      if (!parent) return;

      const blockquote = document.createElement("blockquote");

      // chèn blockquote trước block
      parent.insertBefore(blockquote, block);

      // move block vào trong blockquote
      blockquote.appendChild(block);
    });
  };

  unwrapBlockquote({ blocks }) {

    blocks.forEach((block) => {
      // Tìm blockquote parent
      let current = block;
      let blockquoteParent = null;

      while (current && current !== this.editor.root) {
        if (current.tagName.toLowerCase() === "blockquote") {
          blockquoteParent = current;
          break;
        }
        current = current.parentElement;
      }

      // Nếu tìm thấy blockquote parent, unwrap nó
      if (blockquoteParent) {
        const parent = blockquoteParent.parentNode;
        if (!parent) return;

        // Move tất cả children ra ngoài
        while (blockquoteParent.firstChild) {
          parent.insertBefore(blockquoteParent.firstChild, blockquoteParent);
        }

        // Remove blockquote rỗng
        parent.removeChild(blockquoteParent);
      }
    });
  }
}
